<template>
  <div class="auth-container login-container">
    <img class="logo" alt="Feeds.automated logo" src="/app/images/logo.svg" />
    <p>{{ $t('auth.enter_login_details') }}</p>
    <ValidationObserver ref="observer" v-slot="{ invalid }" class="d-flex flex-column">
      <validation-provider class="mb-4" :rules="{ required: true, email: true }" v-slot="{ errors }">
        <input v-model="email" class="form-control" name="emailAddress" type="email" placeholder="e-mail">
        <span class="validation-error-required">{{ errors[0] }}</span>
      </validation-provider>
      <validation-provider class="password-container mb-4" rules="required" v-slot="{ errors }">
        <input v-model="password" class="form-control" id="passwordInput" name="accountPassword" type="password" :placeholder="$t('auth.password_label')">
        <eye-icon @click="togglePasswordPreview"></eye-icon>
        <span class="validation-error-required" v-if="errors[0] === 'Pole jest wymagane'">{{ $t('validations.required') }}</span>
      </validation-provider>
      <div class="d-flex justify-content-between mb-4">
        <b-form-checkbox id="loginRememberCheckbox" v-model="rememberLogin">{{ $t('auth.remember_me') }}</b-form-checkbox>
        <router-link :to="{ name: 'auth.password-recover'}"><u>{{ $t('auth.remind_password') }}</u></router-link>
      </div>
      <button type="submit" class="btn btn-large btn-orange mb-3" @click="login" :disabled="invalid">{{ $t('auth.login_submit') }}</button>
    </ValidationObserver>
    <router-link :to="{ name: 'auth.register'}" class="register-submit">
      <button type="button" class="btn btn-large btn-gray-dark">{{ $t('auth.register_submit') }}</button>
    </router-link>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import axios from 'axios'
import jwtDecode from 'jwt-decode'
import { EventBus } from '../../event-bus.js'
import { EyeIcon } from 'vue-feather-icons'

extend('required', {
  ...required,
  message: ''
})

extend('email', {
  ...email,
  message: ''
})

export default {
  name: 'Login',

  data () {
    return {
      email: null,
      password: null,
      rememberLogin: false
    }
  },

  created () {
    if (this.$cookies.get('remember_login') == null) {
      this.$cookies.set('remember_login', 'false')
    }
    if (this.$cookies.get('access_token') !== null) {
      const decoded = jwtDecode(this.$cookies.get('access_token'))
      this.$router.push({ name: 'projects', params: { userEmail: decoded.email, userId: decoded.id } })
    }
  },

  mounted () {
    window.addEventListener('keypress', (e) => {
      if (e.keyCode === 13) {
        this.login()
      }
    })
  },

  methods: {
    login () {
      if (this.$refs.observer !== undefined) {
        if (this.$refs.observer.flags.valid) {
          axios.post(process.env.VUE_APP_API_ENDPOINT + '/auth/login', {
            email: this.email,
            password: this.password
          })
            .then((response) => {
              if ((response.status === 201) || (response.status === 200)) {
                if (this.rememberLogin) {
                  this.$cookies.set('remember_login', 'true')
                  this.$cookies.set('access_token', response.data.access_token, '14d')
                } else {
                  this.$cookies.set('remember_login', 'false')
                  this.$cookies.set('access_token', response.data.access_token, '1d')
                }
                EventBus.$emit('tokenSet', response.data.access_token)
                axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.access_token
                this.$emit('onLoginSuccess')
                this.$router.push({ name: 'projects' })
              }
            })
            .catch((error) => {
              if (error.response) {
                const h = this.$createElement
                const message = h(
                  'div',
                  [
                    h('p', this.$t('auth.login_error_description')),
                    h('p', [
                      h('strong', this.$t('global.error_code')),
                      h('span', error.response.data.statusCode)
                    ]),
                    h('p', [
                      h('strong', this.$t('global.error_status')),
                      h('span', error.response.data.message)
                    ])
                  ]
                )
                this.$bvToast.toast([message], {
                  autoHideDelay: 3000,
                  solid: true,
                  title: this.$t('auth.login_error'),
                  variant: 'danger'
                })
              }
            })
        }
      }
    },

    togglePasswordPreview () {
      const passwordInput = document.getElementById('passwordInput')
      if (passwordInput.type === 'password') passwordInput.type = 'text'
      else passwordInput.type = 'password'
    }
  },

  components: { EyeIcon, ValidationObserver, ValidationProvider }
}
</script>
